import { Container, Eyebrow } from './primitives'

const ROWS = [
  {
    point: 'Senior design, not a template.',
    against: 'A Squarespace theme with your headshot dropped in.',
    body:
      'Every exec gets a site nobody recognizes from someone else\u2019s. Typography, layout, tone, designed for you alone.',
  },
  {
    point: 'Live in seven days, always.',
    against: 'Six weeks with a freelancer, then two more on revisions.',
    body:
      'Fixed scope, fixed timeline. You send the brief on Monday, you send clients the link the following Monday.',
  },
  {
    point: 'Fixed price, no surprises.',
    against: 'An estimate that becomes a quote that becomes an invoice.',
    body:
      '$1,999 covers everything in Launch. If you want ongoing edits, $299/mo, cancel whenever.',
  },
  {
    point: 'No calls required.',
    against: 'A 30-minute discovery call before you know the price.',
    body:
      'Stripe Checkout buys the work. Intake is a form. Conversations happen when there is something to talk about.',
  },
]

export function WhyVello() {
  return (
    <section style={{ padding: '96px 0', borderTop: '1px solid var(--line)' }}>
      <Container>
        <div style={{ maxWidth: 720, marginBottom: 64 }}>
          <Eyebrow>Why Vello</Eyebrow>
          <h2
            style={{
              fontSize: 'clamp(32px, 4.2vw, 56px)',
              lineHeight: 1.05,
              letterSpacing: '-0.025em',
              fontWeight: 400,
              margin: '20px 0 0',
              fontFamily: 'var(--serif)',
            }}
          >
            Built for operators, not agencies.
          </h2>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          {ROWS.map((r, i) => (
            <div
              key={r.point}
              className="why-row"
              style={{
                display: 'grid',
                gridTemplateColumns: '80px 1fr 1fr',
                gap: 32,
                padding: '32px 0',
                borderTop: '1px solid var(--line)',
                borderBottom: i === ROWS.length - 1 ? '1px solid var(--line)' : 'none',
              }}
            >
              <div
                style={{
                  fontFamily: 'var(--mono)',
                  fontSize: 13,
                  color: 'var(--accent)',
                  letterSpacing: '0.08em',
                }}
              >
                0{i + 1}
              </div>
              <div>
                <div
                  style={{
                    fontSize: 22,
                    fontWeight: 500,
                    letterSpacing: '-0.015em',
                    lineHeight: 1.25,
                  }}
                >
                  {r.point}
                </div>
                <div
                  style={{
                    fontSize: 14,
                    color: 'var(--muted)',
                    marginTop: 8,
                    fontStyle: 'italic',
                  }}
                >
                  vs.{' '}
                  <span
                    style={{
                      textDecoration: 'line-through',
                      textDecorationColor: 'var(--line-strong)',
                    }}
                  >
                    {r.against}
                  </span>
                </div>
              </div>
              <div style={{ fontSize: 15.5, lineHeight: 1.6, color: 'var(--fg)' }}>
                {r.body}
              </div>
            </div>
          ))}
        </div>
      </Container>
    </section>
  )
}
